module.exports = __webpack_public_path__ + "img/ingolstadt.e9486de3.jpg";